import { getCookie, simulateAsyncOperation, throttle } from "mmbclient/Common/CommonFunctions";
import { checkSession, getAllClients } from "mmbclient/Common/CommonService";
import { AD, API_PATH, APP_TYPE_COOKIE_NAME, CREDIT_BOOK_PICKUP_STATUS_PATH, EP, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_SESSION_NAME, LOGIN_THROTTLE_TIME, PAGE_LOADING_TIME, US, USER_TYPE_COOKIE_NAME, TRACKING_REPORT } from "mmbclient/Common/CommonVariable";
import { useEffect, useState } from "react";
import * as XLSX from 'xlsx';

const CreditPickUpStatusController = (store) => {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [client, setClient] = useState();
    // const [client, setClient] = useState("All");
    const [clientOption, setClientOption] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false); 
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const [modalMessage, setModalMessage] = useState('');
    const [modalType, setModalType] = useState('');
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        // Fetch data from server
        const fetchData = async () => {

            setLoading(true);
            try {
                if (getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP) {
                    await Promise.all([
                        loadAllClients(store),
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                } else {
                    await Promise.all([
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    async function loadAllClients(store) {

        const response = await getAllClients(store);
        let lst_Client = [];
        // lst_Client.push("All");
        if (response.length > 0) {
            let i;
            for (i of response) {
                lst_Client.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
            }
        }
        setClientOption(lst_Client);
        setClient(lst_Client[0]);
    }


    const loggerFunc = () => {
        checkSession(store);
    }

    const betterLoggerFunction = throttle(loggerFunc, LOGIN_THROTTLE_TIME);

    const handleSearch = async () => {

        // Check if the end date is earlier than the start date
        if (endDate < startDate) {
            alert("End date cannot be earlier than start date.");
            return;
        }

        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            return;
        }

        setLoading(true);

        try {
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
            const Data = "Data";
            if (c.length === 4) {
                let query = {};
                if(getCookie(USER_TYPE_COOKIE_NAME) === AD  || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                const clientCode = client.split("|")[1].trim();
                query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": clientCode, "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10) };
                }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                    query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": c[1], "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10) };
                }
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query)
                    })
                };
                const path = API_PATH + CREDIT_BOOK_PICKUP_STATUS_PATH + "get";
                // console.log(path);
                // console.log(query);
                const res = await fetch(path, requestOptions);
                const data = await res.json();
                const response = JSON.parse(data)[0].Data;
                if (response.length > 0 && response !== "Result Not Found") {
                    setData(response);
                } else {
                    setData([]);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setLoading(false);
    };

    const handleClick = async(awb_no,client_code)=>{
        setLoading(true);
        try{
        const cookie = getCookie(LOGIN_COOKIE_NAME);
        const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
        let value  = "";
        if(cookieUserType === "MMB_LIVE"){
            value =  "where pr.awb_no = '"+awb_no+ "' and cm.client_code = '"+client_code+"' ";
        }else if(cookieUserType === "MMB"){
            value =  "where pr.awb_no = '"+awb_no+ "' and cm.client_cd = '"+client_code+"' ";
        }
            const query1 = { "value": value, userType: cookieUserType, userKey: c[0] };
            const requestOptions1 = {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: new URLSearchParams({
                                                                query: JSON.stringify(query1),
                                    })
                            };
                        const path1 = API_PATH + CREDIT_BOOK_PICKUP_STATUS_PATH + "getPickupDocket";
                        const response1 = await fetch(path1,requestOptions1);
                        // Check if the response is binary (PDF) or a string
                        const contentType = response1.headers.get('Content-Type');
 
                    // Check if the response is likely binary (PDF file or any binary data)
                        if (contentType && contentType.includes('application/octet-stream')) {
                            const arrayBuffer = await response1.arrayBuffer();
                            const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
                            const url = URL.createObjectURL(blob);
                                            // 🔥 Open PDF immediately
                            window.open(url, "_blank", "noopener,noreferrer,width=800,height=600");
                        } else {
                            const errText = await response1.text();
                            console.log(errText);
                            alert("This is not available");
                        }
        }catch(e){
            console.log(e);
        }finally{
            setLoading(false);
        }
    }

    

    const escapeCsvValue = (value) => {
        if (typeof value === 'string') {
            // Replace commas, newlines, and carriage returns with semicolons
            value = value.replace(/[,]/g, ';')    // Replace commas with semicolons
                .replace(/[\n]/g, ';')   // Replace newlines with semicolons
                .replace(/[\r]/g, ';');  // Replace carriage returns with semicolons
            // Optionally, escape double quotes by replacing them with two double quotes
            value = value.replace(/"/g, '""');
        }
        return value;
    };

    const exportToCSV = () => {
        const csvRows = [];

        let headers;
        headers = [
            'SNo',
            'AWb No.',
            'Date',
            'Client',
            'Network',
            'Service',
            'Origin Pincode',
            'Origin City',
            'Destination Pincode',
            'Destination City',
            'Destination Country',
            'Do/In',
            'Receiver Phone',
            'Receiver Name',
            'Receiver Address',
        ];

        csvRows.push(headers.join(',')); // Add headers

        data.forEach((item, index) => {
            const values = [
                escapeCsvValue(index + 1),
                escapeCsvValue(item.awb_no || ''),
                escapeCsvValue(item.request_date || ''),
                escapeCsvValue(item.client_code || ''),
                escapeCsvValue(item.network_code || ''),
                escapeCsvValue(item.service_group_code || ''),
                escapeCsvValue(item.origin_pincode || ''),
                escapeCsvValue(item.origin_city || ''),
                escapeCsvValue(item.destination_pincode || ''),
                escapeCsvValue(item.destination_city || ''),
                escapeCsvValue(item.destination_county || ''),
                escapeCsvValue(item.do_in || ''),
                escapeCsvValue(item.consignee_phone || ''),
                escapeCsvValue(item.consignee_name || ''),
                escapeCsvValue(item.consignee_address || ''),
            ];
            csvRows.push(values.join(',')); // Add data row
        });

        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'data.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const exportToExcel = () => {
        if (Array.isArray(data) && data.length === 0) {
            alert("No data found");
            return;
        }

        setLoading(true);
        let ws;
        ws = XLSX.utils.json_to_sheet(data.map((item, index) => ({
            SNo: index + 1,
            'AWb No.': item.awb_no || '',
            'Date': item.request_date || '',
            'Client': item.client_code || '',
            'Network': item.network_code || '',
            'Service': item.service_group_code || '',
            'Origin Pincode': item.origin_pincode || '',
            'Origin City': item.origin_city || '',
            'Destination Pincode': item.destination_pincode || '',
            'Destination City': item.destination_city || '',
            'Destination Country': item.destination_county || '',
            'Do/In': item.do_in || '',
            'Receiver Phone': item.consignee_phone || '',
            'Receiver Name': item.consignee_name || '',
            'Receiver Address': item.consignee_address || '',
        })));

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Data');

        XLSX.writeFile(wb, 'Data.xlsx');
        setLoading(false);
    };


    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const itemsPerPage = 10;

    // Filter data based on search term
    const filteredData = data.filter(item => {

        const lowerCaseSearchTerm = searchTerm.toLowerCase();

        return (
            String(item?.awb_no)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.request_date)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.client_code)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.network_code)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.service_group_code)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.origin_pincode)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.origin_city)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.destination_pincode)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.destination_city)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.destination_county)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.do_in)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.consignee_phone)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.consignee_name)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.consignee_address)?.toLowerCase().includes(lowerCaseSearchTerm)
        );
    }
    );

    // Calculate total pages
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    // Get current items
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectedRows([]);
        } else {
            setSelectedRows(data.map((item) => item.awb_no));
        }
        setSelectAll(!selectAll);
    };

    const toggleRowSelection = (awb_no) => {
        if (selectedRows.includes(awb_no)) {
            setSelectedRows(selectedRows.filter((id) => id !== awb_no));
        } else {
            setSelectedRows([...selectedRows, awb_no]);
        }
    };

    const handleMoveToBooking = () => {
        const userConfirmed = window.confirm("Are you sure you want to move to booking?");

        if (userConfirmed) {
            // Call the function that handles the booking action
            moveToBookingFunction();
        } else {
            // Do nothing if the user clicks "No"
            return;
        }
    };

    const moveToBookingFunction = async () => {

        setLoading(true);
        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            return;
        }

        try {

            const query = data.filter(obj =>
                selectedRows.includes(obj.awb_no)
            );

            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
            const userKey = c[0];
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    userKey: userKey,
                    userType: getCookie(APP_TYPE_COOKIE_NAME),
                })
            };
            const path = API_PATH + CREDIT_BOOK_PICKUP_STATUS_PATH + "save";
            const res = await fetch(path, requestOptions);
            const data1 = await res.json();
            const response = data1;

            if (response.includes("Entry saved.")) {
                setModalMessage('Entry saved.');
                setModalType('success');
                setShowModal(true);

                // Remove processed AWBs from data state
                setData(prevData => prevData.filter(item => !selectedRows.includes(item.awb_no)));
                // Clear selected rows after successful processing
                setSelectedRows([]);
                setSelectAll(false);
            } else {
                setModalMessage('Error : ' + response);
                setModalType('danger');
                setShowModal(true);
            }

        } catch (error) {
            console.error('Error:', error);
            setModalMessage('Failed to save data. Please try again.');
            setModalType('danger');
            setShowModal(true);
        } finally {
            setLoading(false);
        }
    };

    return { searchTerm, setSearchTerm, setCurrentPage, currentItems, currentPage, totalPages, itemsPerPage, clientOption, client, setClient, loading, startDate, setStartDate, endDate, setEndDate, betterLoggerFunction, handleSearch, exportToCSV, exportToExcel, selectAll, setSelectAll, selectedRows, setSelectedRows, toggleSelectAll, toggleRowSelection, handleMoveToBooking, showModal, modalType, modalMessage, setShowModal,handleClick }
}

export default CreditPickUpStatusController;